import { PERMISSIONS } from "../roles-permissions/permission-catalog";
import { defineEntityIdentity } from "../_shared/entity-identity.schemas";

export const cadParcelsIdentity = defineEntityIdentity({
	definitionKey: "cad-parcels",
	pageKey: "cadParcels",
	nameSingular: "cadParcel",
	namePlural: "cadParcels",
	relationKey: "cadParcel",
	auditKey: "cad-parcels",
	storage: "durable",
	grants: {
		read: { ...PERMISSIONS.cadParcels.readAll, audience: "allMembers" },
		create: { ...PERMISSIONS.cadParcels.createAll, audience: "restricted" },
		update: { ...PERMISSIONS.cadParcels.updateAll, audience: "restricted" },
		delete: { ...PERMISSIONS.cadParcels.deleteAll, audience: "restricted" }
	}
});

export const cadParcelTaxHistoryIdentity = defineEntityIdentity({
	definitionKey: null,
	pageKey: "cadParcelTaxHistory",
	nameSingular: "cadParcelTaxHistory",
	namePlural: "cadParcelTaxHistories",
	relationKey: null,
	auditKey: "cadParcelTaxHistories",
	storage: "durable",
	actions: { create: PERMISSIONS.cadParcels.createAll }
});
